import { useRef } from 'react';

import { Paragraph as PropsParagraph } from '@/models/Props';

import useSetProperties from '@/helpers/useSetProperties';

import './Text.scss';

const Text = ({
    fontStyle,
    boldContent,
    normalContent,
    alignCenter,
    row,
}: PropsParagraph) => {
    const textRef = useRef<HTMLParagraphElement>(null);

    const styles = {
        size: `var(--fs-${fontStyle?.size ? fontStyle.size : 'medium'})`,
        weight: `${fontStyle?.weight ? fontStyle.weight : 300}`,
        color: fontStyle?.color ? fontStyle.color : 'var(--text)',
    };

    useSetProperties(styles, textRef);

    const words = normalContent?.split(' ');
    let maxBreak = false;

    words?.forEach((word) => {
        if (word.length > 15) {
            maxBreak = true;
        }
    });

    return (
        <div
            ref={textRef}
            data-grid={'active'}
            // If row is true, display children on different columns
            data-grid-dir={row ? 'columns' : 'rows'}
            className={`text`}
            style={
                alignCenter
                    ? {
                          textAlign: 'center',
                          alignItems: 'center',
                          justifyContent: 'center',
                      }
                    : undefined
            }
        >
            {boldContent ? (
                <p className={'bold__text'}>
                    {Array.isArray(boldContent)
                        ? boldContent.map((line) => `${line}\n`)
                        : boldContent}
                </p>
            ) : null}
            {normalContent ? (
                <p
                    data-text={maxBreak ? 'break' : null}
                    className={'normal__text'}
                >
                    {normalContent}
                </p>
            ) : null}
        </div>
    );
};

export default Text;
